import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import Donut from './Donut/Donut';
import Info from './Info/Info';
import Legend from './Legend/Legend';
import { Heading } from '../../Elements/Elements';

import classes from './Donut3Colors.module.scss';

const Donut3Colors = ({ chartData }) => {
  const { t } = useTranslation(['activity']);

  return (
    <section className={classes.box}>
      <Heading>{t('activity:customers.ACCOUNT_USAGE')}</Heading>
      <div className={classes.body}>
        <Donut data={chartData} />
        <div className={classes.info}>
          <Info data={chartData.infoData} />
          <Legend />
        </div>
      </div>
    </section>
  );
};

Donut3Colors.propTypes = {
  chartData: PropTypes.object
};

export default Donut3Colors;
